/* React */
import React, { useState } from "react";

/* React Redux */
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";

/* Components */
import ListItem from "src/components/insights/custom-cohorts/cohort-list/list-item/ListItem";
import EmptyDataContainer from "src/components/shared/empty-data-container/EmptyDataContainer";

/* Stylesheet */
import styles from "./CohortListContainer.module.scss";
import ListToolbar from "./list-toolbar/ListToolbar";

/* Interfaces */
interface CohortListProps {
  showCohortList: boolean;
  setShowCohortList: React.Dispatch<
    React.SetStateAction<boolean>
  >;
}

const CohortListContainer: React.FC<CohortListProps> = ({
  showCohortList,
  setShowCohortList,
}) => {
  const [editItem, setEditItem] = useState<
    string | undefined
  >(undefined);

  const handleEditItem = (item?: string) => {
    setEditItem(item);
  };

  const customCohortsState = useSelector(
    (state: RootState) => state.customCohorts
  );
  const { currentDiseaseId, customCohortsByDisease } =
    customCohortsState;

  const cohorts = currentDiseaseId
    ? customCohortsByDisease[currentDiseaseId]?.cohorts ??
      []
    : [];

  return (
    <div className={styles.cohort_list_container}>
      <ListToolbar
        showCohortList={showCohortList}
        setShowCohortList={setShowCohortList}
      />
      {cohorts.length > 0 && showCohortList ? (
        <div className={styles.cohort_list}>
          {cohorts.map((cohort, index) => {
            return (
              <ListItem
                key={index}
                index={index}
                item={cohort}
                editItem={editItem}
                handleEditItem={handleEditItem}
              />
            );
          })}
        </div>
      ) : showCohortList ? (
        <EmptyDataContainer
          img={"/assets/img/custom_cohorts.svg"}
          scssProps={{
            img: {
              width: "232px",
            },
          }}
        />
      ) : undefined}
    </div>
  );
};

export default CohortListContainer;
